'use client';

import Link from 'next/link';
import BookDemoSection from '@/components/BookDemoSection';
import { BookDemoButton, Button } from '@/components/ui';
import { useTranslation } from "@/hooks/useTranslation";
const INDUSTRIES = [{
  slug: 'telecom',
  title: 'Telecom',
  icon: '📶',
  desc: 'Predict churn signals and resolve service outrage conversations before they spiral in real-time, at scale.',
  clients: ['Jio', 'Dialog'],
  color: '#0077FF',
  img: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&q=80'
}, {
  slug: 'bfsi',
  title: 'Banking & Finance',
  icon: '🏦',
  desc: 'Turn every digital complaint into a trust-building opportunity, and protect brand reputation during financial crises.',
  clients: ['HDFC Bank', 'Axis Bank', 'Angel Broking'],
  color: '#059669',
  img: 'https://images.unsplash.com/photo-1601597111158-2fceff292cdc?w=600&q=80'
}, {
  slug: 'retail-brands',
  title: 'Retail & E-commerce',
  icon: '🛍️',
  desc: 'Unify online and offline customer feedback to drive footfall, affiliate trust, and store-level CX improvements.',
  clients: ['Titan', 'Kaarigar'],
  color: '#DC2626',
  img: 'https://images.unsplash.com/photo-1556745757-8d76bdb6984b?w=600&q=80'
}, {
  slug: 'healthcare',
  title: 'Healthcare',
  icon: '🏥',
  desc: 'Manage patient sentiment and crisis communications with speed, empathy, and full regulatory awareness.',
  clients: ['Apollo Hospitals'],
  color: '#7C3AED',
  img: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&q=80'
}, {
  slug: 'mobility',
  title: 'Automobile',
  icon: '🚗',
  desc: 'From launch buzz to dealership reviews, monitor the full customer journey across every touchpoint.',
  clients: ['Audi', 'Nissan'],
  color: '#0891B2',
  img: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=600&q=80'
}, {
  slug: 'travel-and-hospitality',
  title: 'Travel & Hospitality',
  icon: '✈️',
  desc: 'Turn post-trip reviews and real-time complaints into loyalty-building service recovery before guests churn.',
  clients: ['Aviation Leaders', 'Hotel Chains'],
  color: '#EA580C',
  img: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=600&q=80'
}, {
  slug: 'fmcg',
  title: 'FMCG',
  icon: '🛒',
  desc: 'Track campaign performance and consumer sentiment across hundreds of SKUs and regional markets simultaneously.',
  clients: ['FMCG Leaders'],
  color: '#CA8A04',
  img: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=600&q=80'
}, {
  slug: 'education',
  title: 'Education',
  icon: '🎓',
  desc: 'Monitor student and parent sentiment at scale to protect institutional reputation and resolve crises fast.',
  clients: ['Coding Ninjas', 'Edtech Brands'],
  color: '#7C3AED',
  img: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=600&q=80'
}, {
  slug: 'technology',
  title: 'Technology',
  icon: '💻',
  desc: 'Stay ahead of product feedback loops and community sentiment so your roadmap reflects what users actually need.',
  clients: ['SaaS Brands', 'Fintech'],
  color: '#0077FF',
  img: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=80'
}, {
  slug: 'government-public-sector',
  title: 'Government & Public',
  icon: '🏛️',
  desc: 'Gauge public concerns early, counter misinformation, and deliver transparent, citizen-first experiences that rebuild civic confidence.',
  clients: ['Uttar Pradesh Police', 'Protean'],
  color: '#059669',
  img: 'https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=600&q=80'
}, {
  slug: 'energy-utilities',
  title: 'Energy Utilities',
  icon: '⚡',
  desc: 'Monitor outage chatter, resolve billing disputes instantly, and deliver clarity that defines modern energy and utilities CX.',
  clients: ['Shell Energy', 'Adani Power'],
  color: '#CA8A04',
  img: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=600&q=80'
}, {
  slug: 'real-estate',
  title: 'Real Estate',
  icon: '🏢',
  desc: 'Build unmatched trust in every property interaction by anticipating buyer needs and protecting your brand with Locobuzz.',
  clients: ['Sobha Realty', 'Danube Properties', 'Shapoorji Pallonji', 'Piramal Realty', 'House of Hiranandani'],
  color: '#7C3AED',
  img: 'https://images.unsplash.com/photo-1582407947304-fd86f28f6e27?w=600&q=80'
}];
const STATS = [{
  n: '350+',
  label: 'Enterprise Clients Globally'
}, {
  n: '50+',
  label: 'Fortune 500 Companies'
}, {
  n: '9',
  label: 'Industries Served'
}, {
  n: '7',
  label: 'Countries & Growing'
}, {
  n: '80%',
  label: 'Faster Customer Engagement'
}];
export default function IndustriesPage() {
  const {
    t
  } = useTranslation();
  return <>
      {/* Hero */}
      <section style={{
      background: '#fff',
      position: 'relative',
      overflow: 'hidden',
      padding: 'var(--hero-pad)'
    }}>
        <div className="lb-hero-grad" style={{
        position: 'absolute',
        inset: 0
      }} />
        <div className="container" style={{
        position: 'relative',
        zIndex: 1,
        textAlign: 'center'
      }}>
          <span className="lb-pill" style={{
          marginBottom: 16
        }}>{t("industries.aipowered_solutions_for_industries")}</span>
          <h1 className="lb-h1" style={{
          maxWidth: 960,
          margin: '0 auto 20px'
        }}>
            {t("industries.trusted_by_the_brands_that")}{' '}
            <span style={{
            background: 'linear-gradient(135deg,#0077FF,#5232FF)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>{t("industries.define_their_industries")}</span>
          </h1>
          <p style={{
          fontSize: 18,
          color: '#4B5563',
          maxWidth: 680,
          margin: '0 auto 36px',
          lineHeight: 1.7
        }}>
            {t("industries.from_indias_largest_bank_to_global")}
          </p>
          <BookDemoButton label={t("industries.book_a_demo")} />
        </div>
      </section>

      {/* Stats strip */}
      <section style={{
      background: '#F8FAFF',
      padding: '32px 0',
      borderTop: '1px solid #E5E7EB',
      borderBottom: '1px solid #E5E7EB'
    }}>
        <div className="container">
          <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 48,
          flexWrap: 'wrap'
        }}>
            {STATS.map(s => <div key={s.n} style={{
            textAlign: 'center'
          }}>
                <div style={{
              fontFamily: "'Inter',sans-serif",
              fontSize: 32,
              fontWeight: 900,
              color: '#0077FF',
              lineHeight: 1,
              marginBottom: 4
            }}>{s.n}</div>
                <div style={{
              fontSize: 12,
              color: '#6B7280'
            }}>{s.label}</div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Built for your sector */}
      <section className="lb-section">
        <div className="container" style={{
        textAlign: 'center'
      }}>
          <div style={{
          fontSize: 13,
          fontWeight: 700,
          color: '#6B7280',
          letterSpacing: '1px',
          textTransform: 'uppercase',
          marginBottom: 12
        }}>{t("industries.built_for_your_sector")}</div>
          <h2 className="lb-h2" style={{
          marginBottom: 12
        }}>{t("industries.every_industry_has_unique_cx_challe")}<br />{t("industries.locobuzz_solves_them")}</h2>
          <p style={{
          fontSize: 16,
          color: '#4B5563',
          maxWidth: 560,
          margin: '0 auto'
        }}>
            {t("industries.select_your_industry_to_explore_tai")}
          </p>
        </div>
      </section>

      {/* Capabilities grid */}
      <section className="lb-section-alt">
        <div className="container">
          <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 32
        }}>
            <h3 className="lb-h3">{t("industries.explore_every_capability")}</h3>
            <span style={{
            fontSize: 13,
            color: '#6B7280'
          }}>{t("industries.click_into_any_module_to_see_how_it")}</span>
          </div>
          <div className="lb-grid-3">
            {INDUSTRIES.map(ind => <Link key={ind.slug} href={'/industries/' + ind.slug} style={{
            textDecoration: 'none'
          }}>
                <div className="lb-card" style={{
              height: '100%',
              overflow: 'hidden',
              padding: 0
            }}>
                  <div style={{
                height: 160,
                overflow: 'hidden',
                position: 'relative'
              }}>
                    <img src={ind.img} alt={ind.title} loading="lazy" decoding="async" style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.4s'
                }} onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
                    <div style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to top,rgba(0,0,0,0.5) 0%,transparent 60%)'
                }} />
                    <div style={{
                  position: 'absolute',
                  bottom: 12,
                  left: 16,
                  fontSize: 28
                }}>{ind.icon}</div>
                  </div>
                  <div style={{
                padding: 20
              }}>
                    <h3 style={{
                  fontFamily: "'Inter',sans-serif",
                  fontWeight: 700,
                  fontSize: 17,
                  color: '#111827',
                  marginBottom: 8
                }}>{ind.title}</h3>
                    <p style={{
                  fontSize: 13,
                  color: '#6B7280',
                  lineHeight: 1.65,
                  marginBottom: 12
                }}>{ind.desc}</p>
                    {ind.clients.length > 0 && <div style={{
                  display: 'flex',
                  gap: 6,
                  flexWrap: 'wrap',
                  marginBottom: 14
                }}>
                        {ind.clients.slice(0, 3).map(c => <span key={c} style={{
                    fontSize: 10,
                    fontWeight: 700,
                    color: '#374151',
                    background: '#F3F4F6',
                    padding: '2px 8px',
                    borderRadius: 4,
                    textTransform: 'uppercase',
                    letterSpacing: '0.3px'
                  }}>{c}</span>)}
                      </div>}
                    <div style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: '#0077FF'
                }}>{t("industries.explore")} {ind.title} →</div>
                  </div>
                </div>
              </Link>)}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section style={{
      background: 'linear-gradient(135deg,#EEF0FF 0%,#F0EEFF 40%,#EBF3FF 100%)',
      padding: 'var(--section-pad)',
      textAlign: 'center'
    }}>
        <div className="container">
          <h2 style={{
          fontFamily: "'Inter',sans-serif",
          fontWeight: 900,
          fontSize: 'clamp(28px,4vw,52px)',
          color: '#0D1117',
          lineHeight: 1.1,
          marginBottom: 20
        }}>
            {t("industries.dont_see_your_industry")}<br />{t("industries.weve_got_you_covered")}
          </h2>
          <p style={{
          fontSize: 16,
          color: '#64748B',
          marginBottom: 32,
          maxWidth: 500,
          margin: '0 auto 32px'
        }}>
            {t("industries.locobuzz_works_with_brands_across_e")}
          </p>
          <Button href="#book-demo" variant="cta" size="lg">{t("industries.try_locobuzz")}</Button>
        </div>
      </section>

      <BookDemoSection />
    </>;
}